//import projects
import Template from './Template';
import prompts from '../../../dummy_data/prompt_engineer/marketing.json';

// External variant
const options = ['SEO', 'Copywriting', 'Sáng tạo nội dung', 'Email Marketing', 'Google Ads', 'Facebook Ads'];

const prompt_persona_role =
    'Phản hồi như một chuyên gia marketing toàn diện giúp tạo ra các chiến lược hiệu quả, gia tăng sự hiện diện trên thị trường và thúc đẩy doanh số.';

export default function Marketing() {
    return (
        <Template
            personaRole={prompt_persona_role}
            data={prompts}
            title="Marketing"
            options={options}
            project="prompt_engineer/marketing"
        />
    );
}
